var React = require('react');

function ItsTimeTriangle1 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M77.779 77.1518L84.5184 13.7761L153.281 85.7836L77.779 77.1518Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M20.5685 99.4264L84.6148 13.7361L77.8542 77.0291L20.5685 99.4264Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M20.5742 99.4277L77.8196 77.0462L153.286 85.7829L20.5742 99.4277Z","fill":"#5915C7","key":2})]);
}

ItsTimeTriangle1.defaultProps = {"width":"154","height":"133","viewBox":"0 0 154 133","fill":"none"};

module.exports = ItsTimeTriangle1;

ItsTimeTriangle1.default = ItsTimeTriangle1;
